module.exports = __webpack_public_path__ + "img/pay6.ad832f3c.png";